import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { loginFormReducer } from '../components/loginForm/loginForm.redux';
import { subscriptionFormReducer } from '../components/subscriptionForm/subscriptionForm.redux';
import { spectreAppReducer } from '../components/spectreApp/spectreApp.redux';
import { sideBarReducer } from '../components/sideBar/sideBar.redux';
import { settingsReducer } from '../components/settings/settings.redux';
import { specsheetReducer } from '../components/specsheet/specsheet.redux';
import { bowlersReducer } from '../components/bowlers/bowlers.redux';
import { arsenalReducer } from '../components/arsenal/arsenal.redux';
import { syncDeviceModalReducer } from '../components/syncDeviceModal/syncDeviceModal.redux';
import { apiReducer } from '../components/api/api.redux';

export const reducers = combineReducers({
  loginForm: loginFormReducer,
  subscriptionForm: subscriptionFormReducer,
  spectreApp: spectreAppReducer,
  sideBar: sideBarReducer,
  settings: settingsReducer,
  specsheet: specsheetReducer,
  form: formReducer,
  bowlers: bowlersReducer,
  balls: arsenalReducer,
  syncDeviceModal: syncDeviceModalReducer,
  api: apiReducer,
});
